import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { NOTIFICATIONS_QUERY_KEYS } from "../queryKeys";
import { getLastSeenNotifications } from "../services/notifications";

export const useGetLastSeenNotification = () => {
  const { i18n } = useTranslation();
  return useQuery({
    queryKey: [...NOTIFICATIONS_QUERY_KEYS.LAST_SEEN_NOTIFICATION, i18n.language],
    queryFn: getLastSeenNotifications,
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  });
};
